import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'enar43',
  Description: 'Here\'s all the online content included with your <strong>English Language Revision Guide</strong>',
  Credits: 'With thanks to Bryn Shortland for the proofreading.\n' +
    'Assessment objective wording licensed under the Open Government Licence. <a href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/" target="_blank">https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/</a>\n' +
    'Clipart from Corel ®\n' +
    'This RevisionHub does not include any official AQA questions and is not endorsed by AQA.\n' +
    'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2025.  All rights reserved.\n',
};
